import * as agentPreview_dto from './agent-preview.dto.mjs';
export { agentPreview_dto as Preview };
import * as agentUserPreview_dto from './agent-user-preview.dto.mjs';
export { agentUserPreview_dto as UserPreview };
import * as balanceSheet_dto from './balance-sheet.dto.mjs';
export { balanceSheet_dto as BalanceSheet };
import * as financialExtraction_dto from './financial-extraction.dto.mjs';
export { financialExtraction_dto as FinancialExtraction };
import * as financialPeriod_dto from './financial-period.dto.mjs';
export { financialPeriod_dto as FinancialPeriod };
import * as incomeStatement_dto from './income-statement.dto.mjs';
export { incomeStatement_dto as IncomeStatement };
import * as z from 'zod';
import { agentUserRoleSchema, usStateOrTerritorySchema } from '../../enums.mjs';
import '../../types/actor/actor.mjs';
import '../../types/address/address.mjs';
import '../../types/credit-report/company-credit-report.mjs';
import '../../types/credit-report/individual-credit-report.mjs';
import '../../types/currency/currency.mjs';
import '../../types/entityRelation/entity-relation.mjs';
import '../../types/financial-formula/adjustable-value.mjs';
import '../../types/financial-formula/adjustable-values-update.mjs';
import '../../types/financial-formula/adjustment.mjs';
import '../../types/financial-formula/formula.mjs';
import '@inrev/core';
import '../../types/is-encrypted.mjs';
import '../../types/naics-codes/naics-codes.mjs';
import { email, phoneNumber, npn, lastName, firstName } from '../../types/opaque.mjs';
import '../../types/surety/account/requested-limits.mjs';
import '../../types/surety/account/surety-account.types.mjs';
import '../../types/surety/application-extraction/application-extraction-output.mjs';
import '../../types/surety/application-extraction/application-extraction-webhook.mjs';
import '../../types/surety/application-extraction/application-review.mjs';
import '../../types/surety/bond/surety-bond.types.mjs';
import '../../types/surety/bond-form/issued/issued-surety-bond-form.types.mjs';
import '../../types/surety/bond-form/surety-bond-form.data.mjs';
import '../../types/surety/bond-request/bond-request-extraction-output.mjs';
import '../../types/surety/bond-request/bond-request-extraction-webhook.mjs';
import '../../types/surety/contract/contract-extraction-output.mjs';
import '../../types/surety/contract/contract-extraction-webhook.mjs';
import '../../types/surety/financial-statement/financial-period/balance-sheet-data.mjs';
import '../../types/surety/financial-statement/financial-period/financial-period-extraction-webhook.mjs';
import '../../types/surety/financial-statement/financial-period/income-statement-data.mjs';
import '../../types/surety/financial-statement/financial-period/income-statement-fields.mjs';
import '../../types/surety/financial-statement/financial-period/income-statement-with-adjustments.mjs';
import '../../types/surety/financial-statement/financial-period/line-item-group.mjs';
import '../../types/surety/financial-statement/financial-period/section-keys.mjs';
import '../../types/surety/financial-statement/financial-period/statement-metadata.mjs';
import '../../types/surety/financial-statement/financial-period/view-shapes.mjs';
import '../../types/surety/financial-statement/financial-statement-schemas.mjs';
import '../../types/surety/indemnity/indemnity-agreement.mjs';
import '../../types/surety/quote/surety-quote.types.mjs';
import '../../types/surety/wip-schedule/wip-schedule-data.mjs';
import '../../types/surety/wip-schedule/wip-schedule-extraction-webhook.mjs';
import '../../types/surety/work-in-progress-statement/surety-work-in-progress-statement.mjs';
import '../../types/user/user.types.mjs';
import '../../types/utils.mjs';

var Invite;
(function (Invite) {
    (function (Request) {
        Request.schema = z.object({
            email: email,
            role: agentUserRoleSchema,
        });
    })(Invite.Request || (Invite.Request = {}));
})(Invite || (Invite = {}));
var CompleteAccountSetup;
(function (CompleteAccountSetup) {
    (function (Request) {
        Request.schema = z.object({
            firstName: firstName,
            lastName: lastName,
            npn: npn,
            phone: phoneNumber,
            residentLicenseState: usStateOrTerritorySchema,
        });
    })(CompleteAccountSetup.Request || (CompleteAccountSetup.Request = {}));
})(CompleteAccountSetup || (CompleteAccountSetup = {}));

export { CompleteAccountSetup, Invite };
